import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 32 32' className={className}>
      <g>
        <line x1='7' x2='25' y1='16' y2='16' stroke={fillColor} strokeLinecap='round' strokeLinejoin='round' strokeWidth='2px' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
